<div class="flex min-h-0 grow flex-col overflow-hidden">
  <button
    type="button"
    (click)="toggleCollapsed()"
    class="flex shrink-0 cursor-pointer items-center gap-2 px-4 py-2.5 text-left"
    [class.border-weak]="!collapsed()"
    [class.border-b]="!collapsed()">
    <span
      class="bg-danger-soft text-danger-hover flex size-[22px] shrink-0 items-center justify-center rounded-md">
      <i [class]="ICONS.warning" class="text-sm"></i>
    </span>

    @if (rowCount() > 0) {
      <span class="text-text-primary text-sm font-semibold">
        {{
          'table.error.summary' | translate: { count: errors().length, rows: rowCount() }
        }}
      </span>
    } @else {
      <span class="text-text-primary text-sm font-semibold">
        {{ 'table.error.summary_count' | translate: { count: errors().length } }}
      </span>
    }

    <span class="text-text-tertiary text-2xs">
      · {{ 'table.error.fix_hint' | translate }}
    </span>

    <div class="flex-1"></div>

    <i
      [class]="collapsed() ? ICONS.caretUp : ICONS.caretDown"
      class="text-text-tertiary text-sm"></i>
  </button>

  @if (!collapsed()) {
    <div class="flex min-h-0 grow flex-col gap-2 overflow-auto px-3 py-2">
      @for (group of groups(); track trackGroup($index, group)) {
        <div class="flex items-start gap-2.5">
          @if (group.rowNumbers.length > 0) {
            <span
              class="text-danger-hover bg-danger-soft text-2xs mt-0.5 shrink-0 rounded-full px-2 py-0.5 font-mono font-semibold">
              @if (group.rowNumbers.length === 1) {
                {{ 'table.error.line' | translate: { row: group.rowNumbers[0] } }}
              } @else {
                {{ rowsLabel(group.rowNumbers) }}
              }
            </span>
          }
          <div class="flex flex-wrap gap-1.5">
            @for (error of group.errors; track trackErrorByMessage($index, error)) {
              <span
                class="bg-elevated border-default text-text-secondary text-2xs inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5">
                @if (error.column) {
                  <span class="text-text-primary font-semibold">{{ error.column }}</span>
                  <span class="text-text-tertiary">—</span>
                }
                <span class="text-danger-hover">{{ error.message }}</span>
              </span>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
